import type { SuccessfulRetrieveCaseResponse } from './types';

/**
 * Type guard that narrows an API response to a successful retrieve-case
 * response. Checks both the `success` flag and the presence of `data`.
 * Used by operations that call `StsBackendClient.getCaseDetails()`.
 *
 * @param response - the raw API response to check
 * @returns true if the response contains valid case data
 */
export function isSuccessResponse(response: {
    /** The response payload. */
    data: unknown;

    /** Whether the API call succeeded. */
    success: boolean;
}): response is SuccessfulRetrieveCaseResponse {
    return response.success === true && response.data !== undefined;
}
